module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar gutter_width_int = parseInt(gutter_width, 10);\nif(gutter_width.length>0 && gutter_width_int<13){ %> <%- namespace %>.view-mosaic .view-tile { padding-left: <%- ''+(gutter_width_int/2) %>px; padding-right: <%- ''+(gutter_width_int/2) %>px; padding-top: <%- ''+(gutter_width_int) %>px; } <%- namespace %>.view-mosaic ul.tile-list-wrapper { margin: 0 <%- '-'+(gutter_width_int/2) %>px; } <% } %> body, <%- namespace %>.view-mosaic { <%- background_color.length>0? 'background-color: '+background_color+';' : '' %> } <%- namespace %>.view-mosaic button.load-more { <%- buttons.load_more.background.length>0? 'background: '+buttons.load_more.background+';' : '' %> <%- buttons.load_more.color.length>0? 'color: ' +buttons.load_more.color+';' : '' %> <%- buttons.load_more.border_radius.length>0? 'border-radius: ' +buttons.load_more.border_radius+';' : '' %> } <%- namespace %>.view-mosaic button.new-posts { <%- buttons.new_posts.background.length>0? 'background: '+buttons.new_posts.background+';' : '' %> <%- buttons.new_posts.color.length>0? 'color: ' +buttons.new_posts.color+';' : '' %> <%- buttons.new_posts.border_radius.length>0? 'border-radius: ' +buttons.new_posts.border_radius+';' : '' %> } <%- namespace %>.view-mosaic .view-tile.view-tile-text.source-flex .tile-wrapper { <%- flex_background_color.length>0? 'background-color: '+flex_background_color+';' : '' %> } <%- namespace %>.view-mosaic .view-tile .media-icons .tile-type { <%- media_icons.display_type.toLowerCase()==='false'? 'display: none;' : '' %> } <% if(media_icons.display_platform.toLowerCase()==='false'){ %> <%- namespace %>.view-mosaic .view-tile .media-icons .wrapper-icon:nth-of-type(2n) { margin: 10px 10px 0 0; } <% } %> <%- namespace %>.view-mosaic .view-tile .media-icons .tile-platform { <%- media_icons.display_platform.toLowerCase()==='false'? 'display: none;' : '' %> } <%- namespace %>.view-mosaic .view-tile .tile-wrapper section.details-wrapper { <%- display_details.toLowerCase()==='false'? 'display: none;' : '' %> } <%- namespace %>.view-mosaic .view-tile.view-tile-text.source-flex p, <%- namespace %>.view-mosaic .view-tile.view-tile-text.source-flex .wrapper-share-buttons span { <%- flex_text_color.length>0? 'color: '+flex_text_color+';' : '' %> } /* Flex Text Tiles */ <% if(typeof background_matte_color === 'string') { %> <% if(background_matte_color.length > 0) { %> <%- namespace %>.view-mosaic .view-tile.view-tile-image.source-flex .tile-wrapper, { background-color: <%- background_matte_color %> !important; } <% } %> <% } %> /* Twitter Tiles Text Color */ <% if(typeof twitter_tile_text_color != \"undefined\"){ %> <%- namespace %>.view-mosaic .view-tile.view-tile-text.source-twitter p { color: <%- twitter_tile_text_color %>; } <% } %> <% if(typeof twitter_tile_text_link_color != \"undefined\"){ %> <%- namespace %>.view-mosaic .view-tile.view-tile-text.source-twitter p a { <%- twitter_tile_text_link_color.length>0? 'color: '+twitter_tile_text_link_color+';' : '' %> } <% } %> /* Facebook Tiles Text Color */ <% if(typeof facebook_tile_text_color != \"undefined\"){ %> <%- namespace %>.view-mosaic .view-tile.view-tile-text.source-facebook p { <%- facebook_tile_text_color.length>0? 'color: '+facebook_tile_text_color+';' : '' %> } <% } %> /* User Details Text Color */ <% if(typeof user_details_text_color != \"undefined\"){ %> <%- namespace %>.view-mosaic .view-tile-details .tile-media .tile-media-body .tile-media-heading { <%- user_details_text_color.length>0? 'color: '+user_details_text_color+';' : '' %> } <% } %> /* Social Actions Color */ <% if(typeof social_actions_facebook_color != \"undefined\"){ %> <%- namespace %>.view-mosaic .view-tile.view-tile-text .text-content .controls-facebook li, <%- namespace %>.view-mosaic .view-tile.view-tile-text .text-content .controls-facebook li a { <%- social_actions_facebook_color.length>0? 'color: '+social_actions_facebook_color+';' : '' %> } <% } %> <% if(typeof social_actions_twitter_color != \"undefined\"){ %> <%- namespace %>.view-mosaic .view-tile.view-tile-text .text-content .controls-twitter li div[class^=\"icon-\"] svg { <%- social_actions_twitter_color.length>0? 'fill: '+social_actions_twitter_color+';' : '' %> } <% } %> /* Media Tiles */ <% if(typeof background_matte_color === 'string') { %> <% if(background_matte_color.length > 0) { %> <%- namespace %>.view-mosaic .view-tile.view-tile-image.source-twitter .tile-wrapper, <%- namespace %>.view-mosaic .view-tile.view-tile-image.source-instagram .tile-wrapper, <%- namespace %>.view-mosaic .view-tile.view-tile-image.source-facebook .tile-wrapper, <%- namespace %>.view-mosaic .view-tile.source-twitter .tile-wrapper, <%- namespace %>.view-mosaic .view-tile.source-facebook .tile-wrapper, <%- namespace %>.view-mosaic .tile-list-wrapper .view-tile.view-tile-image.source-flex .tile-wrapper, <%- namespace %>.view-mosaic .tile-list-wrapper .view-tile.view-tile-video.source-flex .tile-wrapper { <% if(typeof background_media_tile !== 'undefined' && background_media_tile && background_media_tile.length > 0){ %> background-color: <%- background_media_tile %> !important; <% } %> } <% } %> <% } %> /* Social Text Tiles */ <% if(typeof background_matte_color === 'string') { %> <% if(background_matte_color.length > 0) { %> <%- namespace %>.view-mosaic .view-tile.view-tile-text.source-twitter .tile-wrapper, <%- namespace %>.view-mosaic .view-tile.view-tile-text.source-instagram .tile-wrapper, <%- namespace %>.view-mosaic .view-tile.view-tile-text.source-facebook .tile-wrapper { <% if(typeof background_social_tile !== 'undefined' && background_social_tile && background_social_tile.length > 0){ %> background-color: <%- background_social_tile %> !important; <% } %> } <% } %> <% } %> "
  , __filename = undefined;
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var gutter_width_int = parseInt(gutter_width, 10);
if(gutter_width.length>0 && gutter_width_int<13){ 
    ; __line = 3
    ; __append(" ")
    ; __append( namespace )
    ; __append(".view-mosaic .view-tile { padding-left: ")
    ; __append( ''+(gutter_width_int/2) )
    ; __append("px; padding-right: ")
    ; __append( ''+(gutter_width_int/2) )
    ; __append("px; padding-top: ")
    ; __append( ''+(gutter_width_int) )
    ; __append("px; } ")
    ; __append( namespace )
    ; __append(".view-mosaic ul.tile-list-wrapper { margin: 0 ")
    ; __append( '-'+(gutter_width_int/2) )
    ; __append("px; } ")
    ;  } 
    ; __append(" body, ")
    ; __append( namespace )
    ; __append(".view-mosaic { ")
    ; __append( background_color.length>0? 'background-color: '+background_color+';' : '' )
    ; __append(" } ")
    ; __append( namespace )
    ; __append(".view-mosaic button.load-more { ")
    ; __append( buttons.load_more.background.length>0? 'background: '+buttons.load_more.background+';' : '' )
    ; __append(" ")
    ; __append( buttons.load_more.color.length>0? 'color: ' +buttons.load_more.color+';' : '' )
    ; __append(" ")
    ; __append( buttons.load_more.border_radius.length>0? 'border-radius: ' +buttons.load_more.border_radius+';' : '' )
    ; __append(" } ")
    ; __append( namespace )
    ; __append(".view-mosaic button.new-posts { ")
    ; __append( buttons.new_posts.background.length>0? 'background: '+buttons.new_posts.background+';' : '' )
    ; __append(" ")
    ; __append( buttons.new_posts.color.length>0? 'color: ' +buttons.new_posts.color+';' : '' )
    ; __append(" ")
    ; __append( buttons.new_posts.border_radius.length>0? 'border-radius: ' +buttons.new_posts.border_radius+';' : '' )
    ; __append(" } ")
    ; __append( namespace )
    ; __append(".view-mosaic .view-tile.view-tile-text.source-flex .tile-wrapper { ")
    ; __append( flex_background_color.length>0? 'background-color: '+flex_background_color+';' : '' )
    ; __append(" } ")
    ; __append( namespace )
    ; __append(".view-mosaic .view-tile .media-icons .tile-type { ")
    ; __append( media_icons.display_type.toLowerCase()==='false'? 'display: none;' : '' )
    ; __append(" } ")
    ;  if(media_icons.display_platform.toLowerCase()==='false'){ 
    ; __append(" ")
    ; __append( namespace )
    ; __append(".view-mosaic .view-tile .media-icons .wrapper-icon:nth-of-type(2n) { margin: 10px 10px 0 0; } ")
    ;  } 
    ; __append(" ")
    ; __append( namespace )
    ; __append(".view-mosaic .view-tile .media-icons .tile-platform { ")
    ; __append( media_icons.display_platform.toLowerCase()==='false'? 'display: none;' : '' )
    ; __append(" } ")
    ; __append( namespace )
    ; __append(".view-mosaic .view-tile .tile-wrapper section.details-wrapper { ")
    ; __append( display_details.toLowerCase()==='false'? 'display: none;' : '' )
    ; __append(" } ")
    ; __append( namespace )
    ; __append(".view-mosaic .view-tile.view-tile-text.source-flex p, ")
    ; __append( namespace )
    ; __append(".view-mosaic .view-tile.view-tile-text.source-flex .wrapper-share-buttons span { ")
    ; __append( flex_text_color.length>0? 'color: '+flex_text_color+';' : '' )
    ; __append(" } /* Flex Text Tiles */ ")
    ;  if(typeof background_matte_color === 'string') { 
    ; __append(" ")
    ;  if(background_matte_color.length > 0) { 
    ; __append(" ")
    ; __append( namespace )
    ; __append(".view-mosaic .view-tile.view-tile-image.source-flex .tile-wrapper, { background-color: ")
    ; __append( background_matte_color )
    ; __append(" !important; } ")
    ;  } 
    ; __append(" ")
    ;  } 
    ; __append(" /* Twitter Tiles Text Color */ ")
    ;  if(typeof twitter_tile_text_color != "undefined"){ 
    ; __append(" ")
    ; __append( namespace )
    ; __append(".view-mosaic .view-tile.view-tile-text.source-twitter p { color: ")
    ; __append( twitter_tile_text_color )
    ; __append("; } ")
    ;  } 
    ; __append(" ")
    ;  if(typeof twitter_tile_text_link_color != "undefined"){ 
    ; __append(" ")
    ; __append( namespace )
    ; __append(".view-mosaic .view-tile.view-tile-text.source-twitter p a { ")
    ; __append( twitter_tile_text_link_color.length>0? 'color: '+twitter_tile_text_link_color+';' : '' )
    ; __append(" } ")
    ;  } 
    ; __append(" /* Facebook Tiles Text Color */ ")
    ;  if(typeof facebook_tile_text_color != "undefined"){ 
    ; __append(" ")
    ; __append( namespace )
    ; __append(".view-mosaic .view-tile.view-tile-text.source-facebook p { ")
    ; __append( facebook_tile_text_color.length>0? 'color: '+facebook_tile_text_color+';' : '' )
    ; __append(" } ")
    ;  } 
    ; __append(" /* User Details Text Color */ ")
    ;  if(typeof user_details_text_color != "undefined"){ 
    ; __append(" ")
    ; __append( namespace )
    ; __append(".view-mosaic .view-tile-details .tile-media .tile-media-body .tile-media-heading { ")
    ; __append( user_details_text_color.length>0? 'color: '+user_details_text_color+';' : '' )
    ; __append(" } ")
    ;  } 
    ; __append(" /* Social Actions Color */ ")
    ;  if(typeof social_actions_facebook_color != "undefined"){ 
    ; __append(" ")
    ; __append( namespace )
    ; __append(".view-mosaic .view-tile.view-tile-text .text-content .controls-facebook li, ")
    ; __append( namespace )
    ; __append(".view-mosaic .view-tile.view-tile-text .text-content .controls-facebook li a { ")
    ; __append( social_actions_facebook_color.length>0? 'color: '+social_actions_facebook_color+';' : '' )
    ; __append(" } ")
    ;  } 
    ; __append(" ")
    ;  if(typeof social_actions_twitter_color != "undefined"){ 
    ; __append(" ")
    ; __append( namespace )
    ; __append(".view-mosaic .view-tile.view-tile-text .text-content .controls-twitter li div[class^=\"icon-\"] svg { ")
    ; __append( social_actions_twitter_color.length>0? 'fill: '+social_actions_twitter_color+';' : '' )
    ; __append(" } ")
    ;  } 
    ; __append(" /* Media Tiles */ ")
    ;  if(typeof background_matte_color === 'string') { 
    ; __append(" ")
    ;  if(background_matte_color.length > 0) { 
    ; __append(" ")
    ; __append( namespace )
    ; __append(".view-mosaic .view-tile.view-tile-image.source-twitter .tile-wrapper, ")
    ; __append( namespace )
    ; __append(".view-mosaic .view-tile.view-tile-image.source-instagram .tile-wrapper, ")
    ; __append( namespace )
    ; __append(".view-mosaic .view-tile.view-tile-image.source-facebook .tile-wrapper, ")
    ; __append( namespace )
    ; __append(".view-mosaic .view-tile.source-twitter .tile-wrapper, ")
    ; __append( namespace )
    ; __append(".view-mosaic .view-tile.source-facebook .tile-wrapper, ")
    ; __append( namespace )
    ; __append(".view-mosaic .tile-list-wrapper .view-tile.view-tile-image.source-flex .tile-wrapper, ")
    ; __append( namespace )
    ; __append(".view-mosaic .tile-list-wrapper .view-tile.view-tile-video.source-flex .tile-wrapper { ")
    ;  if(typeof background_media_tile !== 'undefined' && background_media_tile && background_media_tile.length > 0){ 
    ; __append(" background-color: ")
    ; __append( background_media_tile )
    ; __append(" !important; ")
    ;  } 
    ; __append(" } ")
    ;  } 
    ; __append(" ")
    ;  } 
    ; __append(" /* Social Text Tiles */ ")
    ;  if(typeof background_matte_color === 'string') { 
    ; __append(" ")
    ;  if(background_matte_color.length > 0) { 
    ; __append(" ")
    ; __append( namespace )
    ; __append(".view-mosaic .view-tile.view-tile-text.source-twitter .tile-wrapper, ")
    ; __append( namespace )
    ; __append(".view-mosaic .view-tile.view-tile-text.source-instagram .tile-wrapper, ")
    ; __append( namespace )
    ; __append(".view-mosaic .view-tile.view-tile-text.source-facebook .tile-wrapper { ")
    ;  if(typeof background_social_tile !== 'undefined' && background_social_tile && background_social_tile.length > 0){ 
    ; __append(" background-color: ")
    ; __append( background_social_tile )
    ; __append(" !important; ")
    ;  } 
    ; __append(" } ")
    ;  } 
    ; __append(" ")
    ;  } 
    ; __append(" ")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

}